import { render, staticRenderFns } from "./Pas.vue?vue&type=template&id=09c5d775&scoped=true&"
import script from "./Pas.vue?vue&type=script&lang=js&"
export * from "./Pas.vue?vue&type=script&lang=js&"
import style0 from "./Pas.vue?vue&type=style&index=0&id=09c5d775&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c5d775",
  null
  
)

export default component.exports